module.exports = __webpack_public_path__ + "static/media/happy.d71efec2.svg";